import React, { PureComponent } from "react";
import { Modal } from "react-bootstrap";
import EventEmitter from "../../services/event-emitter";
import ReactDOM from "react-dom";
import styled from "styled-components";

const IFRAME_REF = "typeform-iframe";

const ModalWrapper = styled(Modal)`
  .knowledge-base-modal {
    min-height: 500px !important;
    width: 85vw !important;
    height: 85vh !important;
    top: 0 !important;

    .modal-content {
      height: 85vh !important;
    }

    .modal-body {
      padding: 0 !important;
      height: 100% !important;
    }
  }
`;

class TypeformModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      url: "",
      additionalClassName: "",
      iframeCustomStyle: {}
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  componentDidMount() {
    this.eventemitter.on("open-typeform-modal", this.open);
  }

  componentWillUnmount() {
    this.eventemitter.off("open-typeform-modal", this.open);
  }

  open = (url, additionalClassName = "", iframeCustomStyle = {}) => {
    this.setState(
      {
        url,
        additionalClassName,
        iframeCustomStyle
      },
      () => {
        this.show();
      }
    );
  };

  show = () => {
    this.setState({
      show: true
    });
  };

  hide = () => {
    this.setState({
      show: false
    });
  };

  onEntered = () => {
    ReactDOM.findDOMNode(this.refs[IFRAME_REF]).focus();
  };

  get modalClassName() {
    const { additionalClassName } = this.state;

    if (additionalClassName !== "") {
      return `typeform-modal ${additionalClassName}`;
    }

    return "typeform-modal";
  }

  render() {
    const { show, url, iframeCustomStyle } = this.state;
    const iframeStyle = {
      width: "100%",
      height: "500px",
      ...iframeCustomStyle
    };

    return (
      <ModalWrapper
        backdrop={true}
        dialogClassName={this.modalClassName}
        show={show}
        onHide={this.hide}
        onEntered={this.onEntered}
      >
        <Modal.Header closeButton={true} />
        <Modal.Body>
          {url !== "" && (
            <iframe ref={IFRAME_REF} src={url} style={iframeStyle} title="Typeform" />
          )}
        </Modal.Body>
      </ModalWrapper>
    );
  }
}

export default TypeformModal;



// WEBPACK FOOTER //
// ./src/components/typeform/modal.js